import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-AIGC",
  "use": "icon-AIGC-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon-AIGC\">\n<g transform=\"translate(2 2) scale(0.75)\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"0.8\" stroke-linecap=\"round\" stroke-linejoin=\"round\">\n\t<path d=\"M5.1,3.3h5.8c1,0,1.8,0.8,1.8,1.8v5.8c0,1-0.8,1.8-1.8,1.8H5.1c-1,0-1.8-0.8-1.8-1.8V5.1C3.3,4.1,4.1,3.3,5.1,3.3z\" />\n\t<path d=\"M6.4,6.5c0-0.7,0.5-1.2,1.2-1.2h0.8c0.7,0,1.2,0.5,1.2,1.2v3c0,0.7-0.5,1.2-1.2,1.2H7.6c-0.7,0-1.2-0.5-1.2-1.2V6.5z\" />\n\t<path d=\"M6.4,7.8h3.2\" />\n\t<path d=\"M8,5.3v5.4\" />\n\t<path d=\"M5.2,1.6v1.7 M8,1.6v1.7 M10.8,1.6v1.7 M5.2,12.7v1.7 M8,12.7v1.7 M10.8,12.7v1.7\" />\n\t<path d=\"M1.6,5.2h1.7 M1.6,8h1.7 M1.6,10.8h1.7 M12.7,5.2h1.7 M12.7,8h1.7 M12.7,10.8h1.7\" />\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/AIGC.svg
// module id = oP3n
// module chunks = 166